import { AppModule } from 'app/module';
import { CompanyCardImageLight } from 'module/companyCardImageLight/main';
import Template from './template.hbs';
import './styles.scss';

export class RelatedCompaniesItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            companyCardImageLight: '.m-companyCardImageLight',
            title: '.m-relatedCompaniesItem__title',
            jobCount: '.m-relatedCompaniesItem__jobCount',
        };
    }

    subs() {
        if (this.dom.companyCardImageLight) {
            this.companyCardImageLight = new CompanyCardImageLight(this.dom.companyCardImageLight);
        }
    }

    getPropsFromDom() {
        return {
            slug: this.dom.el.getAttribute('data-slug'),
            title: this.dom.title ? this.dom.title.innerText : '',
            count: this.dom.jobCount ? this.dom.jobCount.getAttribute('data-count') : false,
            hasOneJob: this.dom.jobCount ? (this.dom.jobCount.getAttribute('data-hasonejob') === 'true') : false,
            hasJobs: this.dom.jobCount ? (this.dom.jobCount.getAttribute('data-hasjobs') === 'true') : false,
            companyCardImageLight:
                this.companyCardImageLight ? this.companyCardImageLight.getPropsFromDom() : false,
        };
    }
}
